class LibraryNewsletter
{
	constructor(newsletterData, optInLink, srcId)
	{
		this.title = newsletterData.Title;
		this.url = newsletterData.links[0] ? newsletterData.links[0].url : "";
		this.optInLink = optInLink;
		this.srcId = srcId;
	}
}

export default LibraryNewsletter;



// WEBPACK FOOTER //
// ./src/models/LibraryNewsletter.js